import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
//import { Navigation } from "./Navigation";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import { useUser } from "./Provider/UserProvider";
import "./Component/Asset.css";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import MemberDataTableForReport from "./Component/MemberDataTableForReport";
import { Grid } from "@mui/material";
import { OwnedGroupSelectBox2 } from "./Component/OwnedGroupSelectBox2";
import Modal from "./Component/Modal";
import { PrintPeriodSelectBox } from "./Component/PrintPeriodSelectBox";
import { API_DOMAIN_URL } from "./Common";
import { STORAGE_DOMAIN_URL } from "./Common";

let fileName = "";
let filePath = "";

export function Report() {
  const navigate = useNavigate();
  const { user } = useUser();
  const [ownedGroups, setOwnedGroups] = useState();
  const [targetGroup, setTargetGroup] = useState();
  const [targetPeriod, setTargetPeriod] = useState();

  const authCheck = () => {
    if (!user || !user.id || user.id == "error") {
      navigate("/SignIn");
      return false;
    }
    return true;
  };

  useEffect(() => {
    authCheck();
  }, []);

  useEffect(() => {
    if (user && user.id) {
      getOwnedGroups(user);
    }
  }, []);

  useEffect(() => {
    if (targetGroup && targetGroup.id) {
      getMembersInGroup(targetGroup.id);
    }
  }, [targetGroup]);

  useEffect(() => {
    if (targetPeriod) {
      console.log("target period changed");
      getMeasurementExistanceInTargetPeriod(targetPeriod);
    }
  }, [targetPeriod]);

  const [membersInGroup, setMembersInGroup] = useState();
  const [membersLoading, setMembersLoading] = useState(false);
  const [targetMembers, setTargetMembers] = useState();
  const [selectionModel, setSelectionModel] = useState([]);

  const getOwnedGroups = (orgUser) => {
    // get organization users data
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL + `/api/GetOwnedGroups?code=${code}&UserId=${orgUser.id}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        setOwnedGroups(response);
      })
      .catch(() => {
        setOwnedGroups([orgUser]);
      });
  };

  const getMembersInGroup = (groupId) => {
    setMembersLoading(true);
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetMembersInTargetGroup?code=${code}&GroupId=${groupId}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        setMembersInGroup(response);
        setMembersLoading(false);

        if (targetPeriod) {
          getMeasurementExistanceInTargetPeriod(targetPeriod, response);
        }
      })
      .catch(() => {
        console.log("no member exists");
        setMembersLoading(false);
      });
  };

  // 測定データ有無取得
  const getMeasurementExistanceInTargetPeriod = (period, resMember) => {
    if (!period) {
      return;
    } else {
      setTargetPeriod(period);
    }

    if (!membersInGroup || membersInGroup.length == 0) {
      return;
    }

    // json作成
    let bodyObj = {};
    let members = [];
    let membersIdAry = [];
    //console.log(resMember);
    if (resMember == undefined) {
      console.log("Set undefined");
      members = membersInGroup;
    } else {
      console.log("Use ResData");
      members = resMember;
    }
    members.forEach((member) => {
      membersIdAry.push(member.id);
    });

    bodyObj.UserIds = membersIdAry;
    bodyObj.Period = period;
    //console.log(bodyObj);
    const bodyString = JSON.stringify(bodyObj);

    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetMeasurementExistanceInTargetPeriod?code=${code}`;
    //console.log(url);
    fetch(url, {
      method: "POST",
      body: bodyString,
    })
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);

        if (!response.MeasureUserIds || response.MeasureUserIds.length == 0) {
          // すべて測定データが不在として×を付加
          console.log("Measurement not exist");
          let updatedTargetMember = [];
          members.forEach((mem) => {
            let memberVal = {};
            Object.assign(memberVal, mem);

            memberVal.DataExists = "×";
            updatedTargetMember.push(memberVal);
          });

          setMembersInGroup(updatedTargetMember);

          if (targetMembers) {
            for (let i = 0; i < targetMembers.length; i++) {
              targetMembers[i].DataExists = "×";
            }
          }
        }
        // add data existance to targetMembers
        if (response.MeasureUserIds && response.MeasureUserIds.length >= 1) {
          let measureUserIds = response.MeasureUserIds;
          let updatedTargetMember = [];

          members.forEach((mem) => {
            let hit = false;
            let memberVal = {};
            Object.assign(memberVal, mem);

            // ユーザーIDがあれば〇を付加
            measureUserIds.forEach((measuredId) => {
              if (mem.id == measuredId) {
                hit = true;
                memberVal.DataExists = "〇";
              }
            });

            // 無ければ×を付加
            if (!hit) {
              memberVal.DataExists = "×";
            }

            updatedTargetMember.push(memberVal);
          });

          if (targetMembers) {
            for (let i = 0; i < targetMembers.length; i++) {
              let hit = false;
              measureUserIds.forEach((measuredId) => {
                if (targetMembers[i].id == measuredId) {
                  targetMembers[i].DataExists = "〇";
                  hit = true;
                }

                if (!hit) {
                  targetMembers[i].DataExists = "×";
                }
              });
            }

            setTargetMembers(targetMembers);
          }

          setMembersInGroup(updatedTargetMember);
        }
      })
      .catch(() => {
        console.log("catched respose");
      });
  };

  const getfileName = (today, nickName) => {
    const year = today.getFullYear().toString();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    const hour = today.getHours().toString().padStart(2, "0");
    const minuite = today.getMinutes().toString().padStart(2, "0");
    const second = today.getSeconds().toString().padStart(2, "0");
    if (nickName != "") {
      nickName = nickName.replace(/[\\/:*?"<>|]/g, '') + "-";
    }
    const fileName = `評価シート-${nickName}${year}-${month}-${day}-${
      hour + minuite + second
    }`;

    return fileName;
  };

  const IndividualPrint = (id) => {
    if (!targetGroup || !targetGroup.id) {
      errorModalOpen("出力失敗", "グループを指定してください");
      return;
    } else if (!targetPeriod) {
      errorModalOpen("出力失敗", "測定年月を指定してください");
      return;
    } else if (!id || id.length == 0) {
      errorModalOpen(
        "出力失敗",
        "評価シート出力対象のメンバーを選択してください"
      );
      return;
    }

    let returnFlg = true;
    let nickName = "";
    for (let i = 0; i < membersInGroup.length; i++) {
      if (membersInGroup[i].id == id) {
        if (membersInGroup[i].DataExists == "〇") {
          returnFlg = false;
          nickName = membersInGroup[i].NickName;
          break;
        } else if (membersInGroup[i].DataExists == "×") {
          break;
        }
      }
    }
    if (returnFlg) {
      errorModalOpen(
        "評価シート出力",
        "測定データが存在しない項目が含まれています。"
      );
      return;
    }

    let userIds = [];
    userIds.push(id);

    let bodyObj = {};
    bodyObj.UserId = user.id;
    bodyObj.GroupId = targetGroup.id;
    bodyObj.UserIds = userIds;
    bodyObj.Period = targetPeriod;
    //console.log(bodyObj);

    const today = new Date();
    fileName = getfileName(today, nickName);
    const year = today.getFullYear().toString();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    filePath = user.id + "/" + year + month + "/" + fileName;
    const extension = "html";

    // Call API
    const bodyString = JSON.stringify(bodyObj);
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/CreateReportJob?code=${code}&filename=${filePath}&extension=${extension}`;
    //console.log(url);

    fetch(url, {
      method: "POST",
      body: bodyString,
    }).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          //console.log(response);
          if (API_DOMAIN_URL.includes("localhost")) {
            response.text().then((html) => {
              downloadFromContent(html, `${fileName}.html`);
            });
          } else {
            downloadFromUrlAutomatically(
              `${STORAGE_DOMAIN_URL}/report/${filePath}.html`,
              `${fileName}.html`
            );
          }

          successModalOpen("帳票HTML出力", "帳票HTMLを出力しました");
        } else if (response.status == 204 || response.status == 400) {
          errorModalOpen("帳票HTML出力", "帳票HTML出力に失敗しました");
        } else {
          errorModalOpen("帳票HTML出力", `帳票HTML出力に失敗しました（エラーコード: ${response.status}）`);
        }
      },
      function (error) {
        console.log(error);
        errorModalOpen("帳票HTML出力", "帳票HTML出力に失敗しました（通信エラー）");
      }
    );
  };

  const Print = () => {
    if (!targetGroup || !targetGroup.id) {
      errorModalOpen("出力失敗", "グループを指定してください");
      return;
    } else if (!targetPeriod) {
      errorModalOpen("出力失敗", "測定年月を指定してください");
      return;
    } else if (!targetMembers || targetMembers.length == 0) {
      errorModalOpen(
        "出力失敗",
        "評価シート出力対象のメンバーを選択してください"
      );
      return;
    }

    let returnFlg = false;
    targetMembers.forEach((el) => {
      if (el.DataExists == "×") {
        errorModalOpen(
          "評価シート出力",
          "測定データが存在しない項目が含まれています。"
        );

        returnFlg = true;
      }
    });
    if (returnFlg) {
      return;
    }

    let userIds = [];
    targetMembers.forEach((member) => {
      userIds.push(member.id);
    });

    let bodyObj = {};
    bodyObj.UserId = user.id;
    bodyObj.GroupId = targetGroup.id;
    bodyObj.UserIds = userIds;
    bodyObj.Period = targetPeriod;
    //console.log(bodyObj);

    const today = new Date();
    fileName = getfileName(today, "");
    const year = today.getFullYear().toString();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    filePath = user.id + "/" + year + month + "/" + fileName;
    const extension = "html";

    // Call API
    const bodyString = JSON.stringify(bodyObj);
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/CreateReportJob?code=${code}&filename=${filePath}&extension=${extension}`;
    //console.log(url);

    fetch(url, {
      method: "POST",
      body: bodyString,
    }).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          //console.log(response);

          if (API_DOMAIN_URL.includes("localhost")) {
            response.text().then((html) => {
              downloadFromContent(html, `${fileName}.html`);
            });
          } else {
            downloadFromUrlAutomatically(
              `${STORAGE_DOMAIN_URL}/report/${filePath}.html`,
              `${fileName}.html`
            );
          }

          successModalOpen("帳票HTML出力", "帳票HTMLを出力しました");
        } else if (response.status == 204 || response.status == 400) {
          errorModalOpen("帳票HTML出力", "帳票HTML出力に失敗しました");
        } else {
          errorModalOpen("帳票HTML出力", `帳票HTML出力に失敗しました（エラーコード: ${response.status}）`);
        }
      },
      function (error) {
        console.log(error);
        errorModalOpen("帳票HTML出力", "帳票HTML出力に失敗しました（通信エラー）");
      }
    );
  };

  function downloadFromContent(html, fileName) {
    const blob = new Blob([html], { type: "text/html" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  function downloadFromUrlAutomatically(url, fileName) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function (e) {
      if (this.status == 200) {
        var urlUtil = window.URL || window.webkitURL;
        var imgUrl = urlUtil.createObjectURL(this.response);
        var link = document.createElement("a");
        link.href = imgUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      console.log(e);
    };
    xhr.send();
  }

  // 更新完了確認のモーダル
  const [successModalStatus, setSuccessModalStatus] = React.useState(false);
  const [successTitle, setSuccessTitle] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const successModalOpen = (title, message) => {
    setSuccessTitle(title);
    setSuccessMessage(message);
    setSuccessModalStatus(true);
  };
  const successModalClose = () => {
    setSuccessModalStatus(false);
  };

  // エラーモーダル
  const [errorModalStatus, setErrorModalStatus] = React.useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const errorModalOpen = (title, message) => {
    setErrorTitle(title);
    setErrorMessage(message);
    setErrorModalStatus(true);
  };
  const errorModalClose = () => {
    setErrorModalStatus(false);
  };

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={4}>
              <Typography component="h1" variant="h5">
                評価シート作成
              </Typography>
            </Grid>
            <Grid item md={8}></Grid>

            <Grid item md={5} mt={2}>
              <OwnedGroupSelectBox2
                ownedGroups={ownedGroups}
                setTargetGroup={setTargetGroup}
              />
            </Grid>
            <Grid item md={3} mt={2}>
              <PrintPeriodSelectBox setTargetPeriod={setTargetPeriod} />
            </Grid>
            <Grid item md={4} mt={2}></Grid>
          </Grid>

          <Grid
            container
            direction="row"
            alignItems="center"
            sx={{ mt: 2, mb: 1 }}
          >
            <Grid item>
              <Button
                variant="outlined"
                disabled={!membersInGroup || membersInGroup.length === 0}
                onClick={() => {
                  const maruMembers = membersInGroup.filter(
                    (m) => m.DataExists === "〇"
                  );
                  setSelectionModel(maruMembers.map((m) => m.id));
                  setTargetMembers(maruMembers);
                }}
              >
                〇のみ一括選択
              </Button>
            </Grid>
          </Grid>

          <MemberDataTableForReport
            members={membersInGroup}
            setTargetMembers={setTargetMembers}
            individualPrint={IndividualPrint}
            selectionModel={selectionModel}
            setSelectionModel={setSelectionModel}
            loading={membersLoading}
          />

          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={4}>
              <Button
                variant="contained"
                color="success"
                sx={{ pr: "50px", pl: "50px", m: "20px" }}
                onClick={() => Print()}
              >
                選択中の評価シートを出力
              </Button>
            </Grid>
            <Grid item md={4}></Grid>
            <Grid item md={4}></Grid>
          </Grid>
        </Box>
      </Container>
      <Modal
        title={errorTitle}
        message={errorMessage}
        status={errorModalStatus}
        okBtnCallback={errorModalClose}
      />
      <Modal
        title={successTitle}
        message={successMessage}
        status={successModalStatus}
        okBtnCallback={successModalClose}
      />
    </div>
  );
}
